/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LayoutEnum,
    LayoutEnumFromJSON,
    LayoutEnumFromJSONTyped,
    LayoutEnumToJSON,
} from './LayoutEnum';
import {
    MailOverviewPeriodEnum,
    MailOverviewPeriodEnumFromJSON,
    MailOverviewPeriodEnumFromJSONTyped,
    MailOverviewPeriodEnumToJSON,
} from './MailOverviewPeriodEnum';
import {
    ThemeEnum,
    ThemeEnumFromJSON,
    ThemeEnumFromJSONTyped,
    ThemeEnumToJSON,
} from './ThemeEnum';
import {
    TimeZoneEnum,
    TimeZoneEnumFromJSON,
    TimeZoneEnumFromJSONTyped,
    TimeZoneEnumToJSON,
} from './TimeZoneEnum';

/**
 * 
 * @export
 * @interface UserSettingsDto
 */
export interface UserSettingsDto {
    /**
     * 
     * @type {ThemeEnum}
     * @memberof UserSettingsDto
     */
    theme: ThemeEnum | null;
    /**
     * 
     * @type {LayoutEnum}
     * @memberof UserSettingsDto
     */
    layout: LayoutEnum | null;
    /**
     * 
     * @type {MailOverviewPeriodEnum}
     * @memberof UserSettingsDto
     */
    mailOverviewPeriod: MailOverviewPeriodEnum | null;
    /**
     * 
     * @type {TimeZoneEnum}
     * @memberof UserSettingsDto
     */
    timezone: TimeZoneEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsDto
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsDto
     */
    showSymbolAmountWarning: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsDto
     */
    showPortfolioValueCalculationInfo: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsDto
     */
    showInLeaderboard: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsDto
     */
    ytdPerformanceCompetitor: boolean;
}

export function UserSettingsDtoFromJSON(json: any): UserSettingsDto {
    return UserSettingsDtoFromJSONTyped(json, false);
}

export function UserSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSettingsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'theme': ThemeEnumFromJSON(json['theme']),
        'layout': LayoutEnumFromJSON(json['layout']),
        'mailOverviewPeriod': MailOverviewPeriodEnumFromJSON(json['mailOverviewPeriod']),
        'timezone': TimeZoneEnumFromJSON(json['timezone']),
        'id': json['id'],
        'userId': json['userId'],
        'showSymbolAmountWarning': json['showSymbolAmountWarning'],
        'showPortfolioValueCalculationInfo': json['showPortfolioValueCalculationInfo'],
        'showInLeaderboard': json['showInLeaderboard'],
        'ytdPerformanceCompetitor': json['ytdPerformanceCompetitor'],
    };
}

export function UserSettingsDtoToJSON(value?: UserSettingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'theme': ThemeEnumToJSON(value.theme),
        'layout': LayoutEnumToJSON(value.layout),
        'mailOverviewPeriod': MailOverviewPeriodEnumToJSON(value.mailOverviewPeriod),
        'timezone': TimeZoneEnumToJSON(value.timezone),
        'id': value.id,
        'userId': value.userId,
        'showSymbolAmountWarning': value.showSymbolAmountWarning,
        'showPortfolioValueCalculationInfo': value.showPortfolioValueCalculationInfo,
        'showInLeaderboard': value.showInLeaderboard,
        'ytdPerformanceCompetitor': value.ytdPerformanceCompetitor,
    };
}

